import React, {
  //
  useState,
  useContext,
} from "react";
import {
  //
  bearlog,
  BearFloat,
  
  BearDiv,
  BearList,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import { getEmoji } from "../consts/emojiConst";
import { getBaseNotes } from "../functions/noteFuncs";

export function EmojiPage(aaaa) {
  const {
    //
    notesAll,
    noteChord,
  } = useContext(MainContext);

  

  const xzcvsd =
    //
    // "";
    noteChord ? noteChord : 1


  const sjass =
    //
    "";
  //   getBaseNotes(-2);

  bearlog.lug("Eojpage---note----zz", xzcvsd);
  const aasad = xzcvsd ? getEmoji(xzcvsd, sjass) : "";
  const { emoji, chord, color, number } = aasad

  bearlog.lug("Eojadsas-zz", aasad);

  // 1click
  function clickEmoj(){
// show 
  }

  const sidjfera = BearDiv({
    obj: chord,
    fontSize: "0.5em"
  })

  // 1list
  const sfdwer = [
    emoji, 
    // number
    sidjfera
  ]

  const ijasaew = {
    bearName: "asdk",
    vertAlign: true,
    onClick: clickEmoj,
    ...aaaa,
  }

  const flotemoj = xzcvsd && BearFloat({
      left: emoji,
      center: sidjfera,
      ...ijasaew,
    });

  const iwreewas = BearList({
      // itemConfig: {
      //   //
      //   fontSize: "18px",
      // },
      list: sfdwer,
      typeList: "return",
      ...ijasaew,
    });

  const iwqesdf = {};
  const ijwerad =
    xzcvsd &&
    // 
    flotemoj
    // iwreewas

  const okfdsd = BearDiv({
    
    obj: ijwerad,
  });

  return okfdsd;
}
